import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaInputComponent } from 'src/app/shared/ui-kit/pa-input/pa-input.component';
import { PaInputOtpComponent } from 'src/app/shared/ui-kit/pa-input-otp/pa-input-otp.component';
import { PaInputPhoneComponent } from 'src/app/shared/ui-kit/pa-input-phone/pa-input-phone.component';
import { CustomErrorMessage } from 'src/app/shared/models/custom-error-messages.model';

@Component({
  selector: 'app-input-view',
  templateUrl: './input-view.component.html',
  styleUrls: ['./input-view.component.scss'],
  standalone: true,
  imports: [
    PaInputComponent,
    PaInputOtpComponent,
    PaInputPhoneComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class InputViewComponent {
  private fb = inject(FormBuilder);

  form = this.fb.group({
    counter: new FormControl(''),
  });

  form2 = this.fb.group({
    counter: new FormControl({ value: 'Выключено', disabled: true }),
  });

  form3 = this.fb.group({
    counter: new FormControl('', Validators.required),
  });

  form4 = this.fb.group({
    counter: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  customErrorMessages: CustomErrorMessage = {
    required: 'Это поле обязательно для заполнения (кастомное сообщение).',
    minlength: (error: { requiredLength?: number; actualLength?: number }) =>
      `Минимум символов: ${error.requiredLength}, сейчас: ${error.actualLength}.`,
  };

  phoneForm1 = this.fb.group({
    phone: new FormControl(''),
  });

  phoneForm2 = this.fb.group({
    phone: new FormControl('', Validators.required),
  });

  phoneForm3 = this.fb.group({
    phone: new FormControl({ value: '+79991234567', disabled: true }),
  });

  phoneForm4 = this.fb.group({
    phone: new FormControl('+79991234567'),
  });

  otpForm = this.fb.group({
    code: new FormControl(''),
  });

  otpErrorForm = this.fb.group({
    code: new FormControl('', Validators.required),
  });

  otpDisabledForm = this.fb.group({
    code: new FormControl({ value: '1234', disabled: true }),
  });
}
